import { getAssetUrl } from 'lib/config/assetUrls';

export enum MealType {
  breakfast = 'breakfast',
  lunch = 'lunch',
  afternoon = 'afternoon',
  dinner = 'dinner',
  midnight = 'midnight',
}

export const TimeToMealMap = {
  [MealType.breakfast]: {
    title: 'Breakfast',
    image: getAssetUrl('/web_v2/icons/food-time/Breakfast.svg'),
  },
  [MealType.lunch]: {
    title: 'Lunch',
    image: getAssetUrl('/web_v2/icons/food-time/Lunch.svg'),
  },
  [MealType.afternoon]: {
    title: 'Afternoon Snack',
    image: getAssetUrl('/web_v2/icons/food-time/Afternoon-snack.svg'),
  },
  [MealType.dinner]: {
    title: 'Dinner',
    image: getAssetUrl('/web_v2/icons/food-time/Dinner.svg'),
  },
  [MealType.midnight]: {
    title: 'Midnight Snack',
    image: getAssetUrl('/web_v2/icons/food-time/Midnight.svg'),
  },
};

export type FoodSpikeType = 'high' | 'medium' | 'stable' | 'low';
